// extracted by mini-css-extract-plugin
module.exports = {"roundedButton":"ValidateButton_roundedButton__2hBWZ","button":"ValidateButton_button__FnrRJ","disabled":"ValidateButton_disabled__33kPK"};